import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cor-data',
  templateUrl: './cor-data.component.html',
  styleUrls: ['./cor-data.component.css']
})
export class CorDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
